import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { AsmService } from '../../../services/asm/asm.service';
import { ScanHistory } from '../../../interfaces/asm/models';
import ApexTree from 'apextree';
import Node from 'apextree';
import { VisualiseDataResponse } from '../../../interfaces/asm/VisualiseDataResponse';

@Component({
    selector: 'app-visualization',
    standalone: true,
    imports: [MatCardModule],
    templateUrl: './visualization.component.html',
    styleUrl: './visualization.component.scss',
})
export class VisualizationComponent {
    // isToggled
    isToggled = false;

    options: any = {
        contentKey: 'name',
        width: 1500,
        height: 800,
        nodeWidth: 500,
        nodeHeight: 30,
        direction: 'left',
        childrenSpacing: 250,
        siblingSpacing: 10,
        canvasStyle: 'border: 1px solid black;background: #f6f6f6;',
        enableToolbar: true,
        enableExpandCollapse: true,
        fontSize: '20px',
        fontFamily: 'arial',
        fontWeight: 600,
    };

    @Input() scan: ScanHistory;
    @ViewChild('svgTree') svgTree: ElementRef<HTMLElement>;

    constructor(
        public themeService: CustomizerSettingsService,
        private asmService: AsmService
    ) {
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    // changeData
    public changeData() {
        if (this.scan) {
            this.asmService
                .getQueryAllScanResultVisualise(this.scan.id)
                .subscribe((response: VisualiseDataResponse[]) => {
                    const tree = new ApexTree(
                        this.svgTree.nativeElement,
                        this.options
                    );
                    const graph = tree.render(
                        this.visualiseDataResponseToNode(response[0])
                    );
                });
        }
    }

    private visualiseDataResponseToNode(data: VisualiseDataResponse): any {
        let children: any[] = [];
        let index: number = 0;

        if(data.children) {
            children = new Array(data.children.length);
            data.children.forEach((elem) => {
                children[index++] = this.visualiseDataResponseToNode(elem);
            });
        }


        const id: string = Math.random().toString();
        let response = {
            id: id,
            name: data.description,
            children: children,
            expanded: false,
        };
        return response;
    }
}
